import { useMemo } from 'react';

import { useAuthHeaders } from '../../auth/use-auth-headers';
import { HttpClient } from '../classes/HttpClient';
import { useTokenRefresherContext } from '../context/token-refresher-context';

/**
 * Creates new instance of HttpClient
 * @returns HttpClient with User & Tenant headers and optional token refresher
 */
export const useHttpClient = () => {
  const defaultHeader = useAuthHeaders();
  const tokenRefresherContext = useTokenRefresherContext();

  return useMemo(() => {
    return new HttpClient(defaultHeader, tokenRefresherContext?.refreshToken);
  }, [defaultHeader, tokenRefresherContext]);
};
